import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import moment from 'moment';
import { get, orderBy, isEmpty, find } from 'lodash';
import { object } from 'prop-types';
import TablePolls from './TablePolls';
import Filters from './filters';
import DrawerFormPoll from './DrawerFormPoll/DrawerFormPoll';
import DrawerRequired from './DrawerRequired';
import ModalConfirmation from './ModalConfirmation';
import ModalWarningRequired from './ModalWarningRequired';
import { Main, Pagination, Loading, TableCount, Button } from '../../common';
import GET_POLLS from '../../../queries/GET_POLLS';

const Polls = ({ session, client }) => {
    const [drawerPoll, setDrawerPoll] = useState({ visible: false, isCreate: false, pollSelected: {} });
    const [visibleDrawerRequired, setVisibleDrawerRequired] = useState(false);
    const [visibleModalWarningRequired, setVisibleModalWarningRequired] = useState(false);
    const [visibleModalConfirmation, setVisibleModalConfirmation] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(null);
    const [defaultPage, setDefaultPage] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [polls, setPolls] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [filters, setFilters] = useState({});
    const [modalAction, setModalAction] = useState(false);
    const [renderComponent, setRenderComponent] = useState(true);

    const handleFilters = (input) => {
        setFilters(input);
    };

    const refreshComponent = () => {
        setTimeout(() => {
            setRenderComponent(false);
            setRenderComponent(true);
        }, 500);
    };

    const onCloseDrawerPoll = () => {
        setDrawerPoll({ visible: false, isCreate: false, pollSelected: {} });
        refreshComponent();
    };

    const handleDrawerFromCreate = () => {
        setDrawerPoll({ visible: true, isCreate: true, pollSelected: {} });
    };

    const handleDrawerRequired = (poll) => {
        setDrawerPoll({ ...drawerPoll, pollSelected: poll });
        poll && isEmpty(get(poll, 'associatedStore'))
            ? setVisibleModalWarningRequired(!visibleModalWarningRequired)
            : setVisibleDrawerRequired(!visibleDrawerRequired);
    };

    const handleModalConfirmation = (poll, action) => {
        setVisibleModalConfirmation(!visibleModalConfirmation);
        setDrawerPoll({ ...drawerPoll, pollSelected: poll });
        setModalAction(action);
    };

    const handleEdit = (poll) => {
        setDrawerPoll({ visible: true, isCreate: false, pollSelected: poll });
    };

    const onCloseModal = () => {
        setVisibleModalConfirmation(false);
        setTimeout(() => {
            setModalAction('');
            setDrawerPoll({ ...drawerPoll, pollSelected: {} });
        }, 500);

        refreshComponent();
    };

    const onCloseModalWarningRequired = () => setVisibleModalWarningRequired(false);

    const onSubmit = async () => {
        setLoadingTable(true);
        getPolls(filters, 1);
    };

    const getPolls = async (filters) => {
        const { data } = await client.query({
            query: GET_POLLS,
            variables: {
                filters,
                size: pageSize,
                page: defaultPage || currentPage === null ? 1 : currentPage
            },
            fetchPolicy: 'network-only'
        });

        setPolls(orderBy(get(data, 'getPolls.payload'), 'dateCreate', 'desc'));
        setTotalRecords(get(data, 'getPolls.totalRecords', 0));
        setLoading(false);
        setLoadingTable(false);
    };

    const initDate = isEmpty(filters) ? [
        {
            'field': 'date_create',
            'value': `${moment().subtract(30, 'days').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`
        }
    ] : filters;

    useEffect(() => {
        !isEmpty(filters) && onSubmit();
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        getPolls(initDate);
    }, []);

    useEffect(() => {
        setLoadingTable(true);
        if (currentPage !== null) {
            getPolls(initDate);
            setDefaultPage(null);
        }
    }, [currentPage, pageSize]);

    const refreshData = async () => {
        setLoadingTable(true);
        getPolls(initDate);
    };

    return <Main withFooter background='f4f4f4'>
        <Filters handleFilters={handleFilters} />
        <Loading loading={loading}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 25px', marginBottom: 5, alignItems: 'flex-end' }}>
                <Button type='primary' onClick={handleDrawerFromCreate} width={350}>
                    Crear encuesta
                </Button>
                <TableCount count={totalRecords} />
            </div>
            <TablePolls
                handleEdit={handleEdit}
                handleRequired={handleDrawerRequired}
                handleModalConfirmation={handleModalConfirmation}
                data={polls}
                loading={loadingTable}
            />
            <Pagination
                pageSize={pageSize}
                onChangePageSize={({ value }) => {
                    setCurrentPage(1);
                    setPageSize(get(value, 'value', 50));
                }}
                onChange={value => setCurrentPage(value)}
                current={defaultPage || (currentPage === null ? 1 : currentPage)}
                total={totalRecords}
                customPageSizeOptions={[
                    { value: 10, label: '10' },
                    { value: 50, label: '50' }
                ]}
            />
            {renderComponent && <DrawerFormPoll
                visible={drawerPoll.visible}
                onClose={onCloseDrawerPoll}
                pollSelected={drawerPoll.pollSelected}
                isCreate={drawerPoll.isCreate}
                session={session}
                client={client}
                refreshData={refreshData}
            />}
            <DrawerRequired
                visible={visibleDrawerRequired}
                handleDrawer={handleDrawerRequired}
                session={session}
                pollSelected={find(polls, { idPoll: get(drawerPoll.pollSelected, 'idPoll') })}
                client={client}
                refreshData={refreshData}
            />
            {renderComponent && <ModalConfirmation
                visible={visibleModalConfirmation}
                onClose={onCloseModal}
                pollSelected={drawerPoll.pollSelected}
                client={client}
                action={modalAction}
                refreshData={refreshData}
                session={session}
            />}
            {renderComponent && <ModalWarningRequired
                visible={visibleModalWarningRequired}
                onClose={onCloseModalWarningRequired}
                pollSelected={drawerPoll.pollSelected}
            />}
        </Loading>
    </Main>;
};

Polls.propTypes = {
    session: object,
    client: object
};

export default withRouter(withApollo(Polls));
